/**
 * Decodes a string claim from a JWT payload. Returns '' if the token is
 * malformed or the claim is missing/non-string. Never throws.
 *
 * Handles base64url (with `-` / `_` and no padding) by normalizing to
 * standard base64 before decoding.
 */
export function decodeJwtClaim(token: string, claim: string): string {
  const parts = token.split('.');
  if (parts.length !== 3) return '';
  try {
    const b64url = parts[1];
    const b64 = b64url.replace(/-/g, '+').replace(/_/g, '/');
    const padded = b64 + '='.repeat((4 - (b64.length % 4)) % 4);
    const json = atob(padded);
    const payload = JSON.parse(json) as Record<string, unknown>;
    const value = payload[claim];
    return typeof value === 'string' ? value : '';
  } catch {
    return '';
  }
}

/** Cognito Username from the access token JWT `username` claim. */
export function decodeJwtUsername(token: string): string {
  return decodeJwtClaim(token, 'username');
}

/** Cognito device key from the access token JWT `device_key` claim. */
export function decodeJwtDeviceKey(token: string): string {
  return decodeJwtClaim(token, 'device_key');
}
